import { ref } from "vue";

/**
 * 地图星光灯光模式的全局状态。
 * 星光模式下让 App.vue 顶部导航复用星云页的导航效果（topbar.is-nebula），
 * 而不是另造一套样式。
 */
export const mapNebulaMode = ref(false);

export function useMapNebulaMode() {
  return mapNebulaMode;
}
